import { render, staticRenderFns } from "./AppCoreHeader.vue?vue&type=template&id=0a02d2d8&scoped=true"
import script from "./AppCoreHeader.vue?vue&type=script&lang=js"
export * from "./AppCoreHeader.vue?vue&type=script&lang=js"
import style0 from "./AppCoreHeader.vue?vue&type=style&index=0&id=0a02d2d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a02d2d8",
  null
  
)

export default component.exports